import { useSelector } from 'react-redux';

import type { RootState } from 'wanderu-analytics';
import { variantsSelectors } from 'wanderu-analytics';
import {
    filterSelectors,
    serializeFilterParams,
} from 'wanderu-ducks-search';

import type {
    ActiveSortType,
    SearchParams,
    SortData,
    UseSortDataSelectorParams,
} from './types';

export const useSortDataSelector = ({ date, searchParams }: UseSortDataSelectorParams) => {
    const paramString = searchParams.direction === 'depart'
        ? serializeFilterParams({ ...searchParams, departDate: date })
        : serializeFilterParams({ ...searchParams, returnDate: date });

    const daySelector = (state: RootState): SortData => filterSelectors
        .selectSortOptions(state, paramString);

    return useSelector(daySelector);
};

export const useSortTypeSelector = (searchParams: SearchParams): ActiveSortType => {
    const sortTypeSelector = (state: RootState) => filterSelectors
        .selectActiveSortType(state, searchParams);

    return useSelector(sortTypeSelector);
};

export const useVariantSelector = (flagName: string) => {
    const variantSelector = (state: RootState) => variantsSelectors.selectById(state, flagName);

    return useSelector(variantSelector);
};
